<template>
    <common-modal width="small" @close="emitEvent({ name: 'close' })">
        <common-content-wrapper width="small">
            <common-content-spacer height="medium">
                <div class="modal-header">
                    <common-icon v-if="showWarningIcon" name="white-warning" size="medium-large"></common-icon>
                    <span class="modal-header--text">{{ headingText }}</span>
                </div>

                <p>{{ contentText }}</p>

                <common-buttons>
                    <common-button
                        :label="noButtonText"
                        :isSubmittable="false"
                        :size="buttonSize"
                        type="secondary"
                        @click="emitEvent({ name: 'close' })"
                    ></common-button>
                    <common-button
                        :label="yesButtonText"
                        :isSubmittable="false"
                        :size="buttonSize"
                        type="primary"
                        @click="emitEvent({ name: 'continue' })"
                    ></common-button>
                </common-buttons>
            </common-content-spacer>
        </common-content-wrapper>
    </common-modal>
</template>

<script>
    import ScreenSizeDetectionMixin from 'mixins/ScreenSizeDetectionMixin'
    export default {
        mixins: [ScreenSizeDetectionMixin],
        props: {
            headingText: { type: String, required: true },
            contentText: { type: String, required: true },
            noButtonText: { type: String, required: true },
            yesButtonText: { type: String, required: true },
            showWarningIcon: { type: Boolean, default: false },
        },

        computed: {
            buttonSize() {
                return this.isTabletSmall ? 'small-font' : 'large'
            },
        },
    }
</script>

<style scoped lang="scss">
    @import 'styles/setup/_variables.scss';
    .modal-header {
        display: flex;
        justify-content: center;
        align-items: center;

        .icon {
            margin-right: 10px;
        }

        &--text {
            line-height: $line-height--heading;
            font-size: 20px;
            font-weight: 700;
        }
    }
</style>
